import { AnimatePresence, motion } from "framer-motion";
import { Volume2, Pause, Play, X } from "lucide-react";
import { useReadAloud } from "@/context/ReadAloudContext";

export const ReadAloudControls = () => {
  const ra = useReadAloud();
  if (!ra?.supported) return null;

  return (
    <AnimatePresence>
      {ra.speaking && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ type: "spring", stiffness: 300, damping: 26 }}
          data-testid="read-aloud-controls"
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 rounded-full bg-pula-ink text-white shadow-xl pl-4 pr-1.5 py-1.5">
          <span className="flex items-center gap-2 text-sm font-body font-medium pr-2">
            <Volume2 className="w-4 h-4 text-pula-green animate-pulse" /> Reading page aloud
          </span>
          {ra.paused ? (
            <button data-testid="read-aloud-resume" onClick={ra.resume} aria-label="Resume reading"
              className="w-9 h-9 rounded-full grid place-items-center hover:bg-white/15 transition-colors">
              <Play className="w-4 h-4" />
            </button>
          ) : (
            <button data-testid="read-aloud-pause" onClick={ra.pause} aria-label="Pause reading"
              className="w-9 h-9 rounded-full grid place-items-center hover:bg-white/15 transition-colors">
              <Pause className="w-4 h-4" />
            </button>
          )}
          <button data-testid="read-aloud-stop" onClick={ra.stop} aria-label="Stop reading"
            className="w-9 h-9 rounded-full grid place-items-center bg-white/10 hover:bg-pula-accent transition-colors">
            <X className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
